<div class="load-more">
    LOAD MORE
</div>